import { useQuery } from 'react-query';
import {
  DjangoListResponse,
  SearchEntity,
  ArtificialProposalResponse,
} from 'v2/models';
import restFactory from 'v2/utils/restFactory';

interface useArtificialResponsesParams {
  search?: SearchEntity;
  page?: number;
  enabled?: boolean;
}

export function useArtificialResponses({
  search,
  page = 1,
  enabled = true,
}: useArtificialResponsesParams) {
  const result = useQuery(
    ['ArtificialProposalResponse', { search, page }],
    async () => {
      return await restFactory.get<
        DjangoListResponse<ArtificialProposalResponse>
      >(`/dj/api/v1/artificial_proposal_response/`, {
        page: page,
        search: search?.id,
        processed_response: true,
      });
    },
    { cacheTime: 0, enabled: enabled }
  );

  return result;
}
